import { CloseRounded, ExpandLess, ExpandMore } from "@mui/icons-material";
import {
  Dialog,
  Box,
  DialogTitle,
  IconButton,
  List,
  ListItemButton,
  ListItemText,
  Collapse,
  ListItemIcon,
  Checkbox,
} from "@mui/material";
import { Dispatch, FC, SetStateAction } from "react";
import { useTranslation } from "react-i18next";
import { useInventory } from "../../../InventoryProvider";
import { Filters } from "../../../../../types/inventoryData";

type FilterDialogPhoneTypes = {
  phoneFilterDialog: boolean;
  setPhoneFilterDialog: Dispatch<SetStateAction<boolean>>;
  handleToggle: (id: string) => void;
  phoneFilterOpen: Record<string, boolean>;
};

const FilterDialogPhone: FC<FilterDialogPhoneTypes> = ({
  phoneFilterDialog,
  setPhoneFilterDialog,
  handleToggle,
  phoneFilterOpen,
}) => {
  const { rows, headCells, selectedFilterValues, setSelectedFilterValues } =
    useInventory();

  const { t } = useTranslation();

  const handleFilterChange = (headCell: string, newFilterValue: any) => {
    setSelectedFilterValues((prev) => {
      const prevValues: (string | number)[] =
        prev[headCell as keyof Filters] || [];

      const exists = prevValues.includes(newFilterValue);
      const updatedValues = exists
        ? prevValues.filter((v) => v !== newFilterValue)
        : [...prevValues, newFilterValue];

      return {
        ...prev,
        [headCell]: updatedValues,
      };
    });
  };

  return (
    <Dialog
      open={phoneFilterDialog}
      onClose={() => setPhoneFilterDialog(false)}
      fullScreen
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <DialogTitle>{t("inventory.filters")}</DialogTitle>
        <IconButton>
          <IconButton
            onClick={() => setPhoneFilterDialog(false)}
            sx={{
              p: 2,
              display: "flex",
              alignItems: "center",
              "&:hover": { cursor: "pointer" },
            }}
          >
            <CloseRounded />
          </IconButton>
        </IconButton>
      </Box>
      {headCells.map((headCell) => {
        if (headCell.id === "actions") return;

        const data = [
          ...new Set(
            rows
              .map((r) => headCell.getValue(r))
              .filter((value) => value !== null && value !== undefined)
          ),
        ];

        if (data.length === 0) return;

        return (
          <List>
            <ListItemButton
              onClick={() => {
                handleToggle(headCell.id);
              }}
            >
              <ListItemText primary={t(headCell.label)} />
              {phoneFilterOpen[headCell.id] ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>

            <Collapse
              in={phoneFilterOpen[headCell.id]}
              timeout="auto"
              unmountOnExit
            >
              <List disablePadding>
                {data.map((value) => {
                  const selectedFilter: (string | number)[] =
                    selectedFilterValues[headCell.id as keyof Filters];
                  const selected = selectedFilter.includes(value);

                  return (
                    <ListItemButton
                      onClick={() => handleFilterChange(headCell.id, value)}
                    >
                      <ListItemIcon>
                        <Checkbox edge="start" checked={selected} />
                      </ListItemIcon>
                      <ListItemText primary={value} />
                    </ListItemButton>
                  );
                })}
              </List>
            </Collapse>
          </List>
        );
      })}
    </Dialog>
  );
};

export default FilterDialogPhone;
